import { render, staticRenderFns } from "./PopUpGeneratedReports.vue?vue&type=template&id=8157b9fe&"
import script from "./PopUpGeneratedReports.vue?vue&type=script&lang=ts&"
export * from "./PopUpGeneratedReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports